'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _common = require('../common');

var _constants = require('../../../src/constants');

var _utils = require('../../utils');

var _CaseActivity = require('./CaseActivity');

var _CaseActivity2 = _interopRequireDefault(_CaseActivity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ACTIVITY_STATUS_CLASSNAMES = _constants.AppConstants.ACTIVITY_STATUS_CLASSNAMES,
    ACTIVITY_FILE_NAME_TRUNCATE_LENGTH = _constants.AppConstants.ACTIVITY_FILE_NAME_TRUNCATE_LENGTH;
var SentFax = (_dec = (0, _mobxReact.inject)('CaseStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(SentFax, _Component);

  function SentFax() {
    _classCallCheck(this, SentFax);

    return _possibleConstructorReturn(this, (SentFax.__proto__ || Object.getPrototypeOf(SentFax)).apply(this, arguments));
  }

  _createClass(SentFax, [{
    key: 'download',
    value: function download() {
      var _props = this.props,
          CaseStore = _props.CaseStore,
          activity = _props.activity;

      CaseStore.downloadSentFax(activity.download_url);
    }
  }, {
    key: 'getStatus',
    value: function getStatus() {
      return (0, _get3.default)(this.props.activity, 'fax.last_status_event.status_label', 'unknown');
    }
  }, {
    key: 'render',
    value: function render() {
      var formatPhoneNumber = _utils.FormattingUtils.formatPhoneNumber,
          truncate = _utils.FormattingUtils.truncate,
          activity = this.props.activity,
          status = this.getStatus(),
          statusClassName = status && ACTIVITY_STATUS_CLASSNAMES[status.toLowerCase()],
          download_link = _react2.default.createElement(
        _Button2.default,
        { bsStyle: 'link', onClick: this.download },
        _react2.default.createElement(_common.Icon, { type: 'download' }),
        truncate(activity.fax.content_filename, ACTIVITY_FILE_NAME_TRUNCATE_LENGTH)
      ),
          body = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          'FAX'
        ),
        _react2.default.createElement(
          _Row2.default,
          { className: 'status' },
          _react2.default.createElement(
            'h4',
            null,
            'Status:'
          ),
          ' ',
          _react2.default.createElement(
            'span',
            { className: statusClassName },
            status
          )
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'h4',
            null,
            'Fax number:'
          ),
          ' ',
          formatPhoneNumber(activity.fax.number_to)
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'h4',
            null,
            'Recipient\'s name:'
          ),
          ' ',
          activity.sent_fax_meta.fax_name
        ),
        _react2.default.createElement(
          _Row2.default,
          { className: 'files' },
          download_link
        )
      );

      return _react2.default.createElement(_CaseActivity2.default, _extends({ activity_body: body }, this.props, { deletableActivityType: false }));
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return SentFax;
}(_react.Component), _class2.propTypes = {
  activity: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired
  }).isRequired,
  CaseStore: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class) || _class);
var _default = SentFax;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ACTIVITY_STATUS_CLASSNAMES, 'ACTIVITY_STATUS_CLASSNAMES', '/app/src/components/common-activities/SentFax.js');
  reactHotLoader.register(ACTIVITY_FILE_NAME_TRUNCATE_LENGTH, 'ACTIVITY_FILE_NAME_TRUNCATE_LENGTH', '/app/src/components/common-activities/SentFax.js');
  reactHotLoader.register(SentFax, 'SentFax', '/app/src/components/common-activities/SentFax.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-activities/SentFax.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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